import Colors from '@/v2/constants/Colors';
import {
  CloseCircleOutlined,
  ExclamationCircleFilled,
  InfoCircleFilled,
  WarningFilled,
} from '@ant-design/icons';

const notificationDefaultTop = 24;
const notificationDefaultRight = 24;
const notificationGapToRef = 24;

const baseConfig = {
  placement: 'topRight',
  className: 'custom-notification',
  style: {
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 12,
    padding: 16,
    marginTop: notificationDefaultTop,
    marginRight: 0,
  },
  top: 0,
};

const createNotificationConfig = (overrides = {}) => {
  const { style, ...restOverrides } = overrides;

  return {
    ...baseConfig,
    style: {
      ...baseConfig.style,
      ...style,
    },
    ...restOverrides,
  };
};

const iconSize = 20;
const closeIconSize = 20;

export const getTypeConfig = (type) =>
  ({
    success: createNotificationConfig({
      style: {
        backgroundColor: Colors.SUCCESS_VARIANTS[10],
        borderColor: Colors.SUCCESS_VARIANTS[30],
      },
      icon: (
        <InfoCircleFilled
          style={{ color: Colors.SUCCESS_VARIANTS[60], fontSize: iconSize }}
        />
      ),
      closeIcon: (
        <CloseCircleOutlined
          style={{
            color: Colors.SUCCESS_VARIANTS[60],
            fontSize: closeIconSize,
          }}
        />
      ),
    }),
    error: createNotificationConfig({
      style: {
        backgroundColor: Colors.ERROR_VARIANTS[10],
        borderColor: Colors.ERROR_VARIANTS[30],
      },
      icon: (
        <WarningFilled
          style={{ color: Colors.ERROR_VARIANTS[60], fontSize: iconSize }}
        />
      ),
      closeIcon: (
        <CloseCircleOutlined
          style={{ color: Colors.ERROR_VARIANTS[60], fontSize: closeIconSize }}
        />
      ),
      duration: 0,
    }),
    warning: createNotificationConfig({
      style: {
        backgroundColor: Colors.WARNING_VARIANTS[10],
        borderColor: Colors.WARNING_VARIANTS[30],
      },
      icon: (
        <ExclamationCircleFilled
          style={{ color: Colors.WARNING_VARIANTS[70], fontSize: iconSize }}
        />
      ),
      closeIcon: (
        <CloseCircleOutlined
          style={{
            color: Colors.WARNING_VARIANTS[70],
            fontSize: closeIconSize,
          }}
        />
      ),
    }),
    info: createNotificationConfig({
      style: {
        backgroundColor: Colors.MAIN_VARIANTS[10],
        borderColor: Colors.MAIN_VARIANTS[30],
      },
      icon: (
        <InfoCircleFilled
          style={{ color: Colors.MAIN_VARIANTS[60], fontSize: iconSize }}
        />
      ),
      closeIcon: (
        <CloseCircleOutlined
          style={{ color: Colors.MAIN_VARIANTS[60], fontSize: closeIconSize }}
        />
      ),
    }),
  })[type];

export function getConfFromRef(prevConfig, ref) {
  const rect = ref.current.getBoundingClientRect();

  const bottom =
    window.innerHeight - rect.top - rect.height + notificationGapToRef;
  const right = window.innerWidth - rect.right;

  const config = {
    ...prevConfig,
    style: {
      ...prevConfig.style,
      bottom,
      marginRight: right - notificationDefaultRight,
    },
    placement: 'bottomRight',
  };

  return config;
}
